
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 55 75"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"fill":"currentColor","d":"M54.284 27.58a27.005 27.005 0 00-6.476-17.565 27.008 27.008 0 00-34.69-5.455A26.995 26.995 0 001.563 19.282a26.992 26.992 0 00.79 18.701 27.002 27.002 0 0012.762 13.7v3.657a1.135 1.135 0 002.202 0v-2.659a26.892 26.892 0 0019.912 0v9.819a1.135 1.135 0 002.202 0V51.692a26.982 26.982 0 0010.835-9.956 27.028 27.028 0 004.018-14.156zM27.273 52.389A24.815 24.815 0 019.73 45.122a24.818 24.818 0 010-35.086 24.809 24.809 0 0117.543-7.262c6.579 0 12.89 2.61 17.543 7.262a24.816 24.816 0 017.262 17.543 24.809 24.809 0 01-7.271 17.534 24.84 24.84 0 01-17.534 7.276z"}}),_c('path',{attrs:{"fill":"#BF9C5F","d":"M40.034 22.327H31.09l-2.761-8.51a1.136 1.136 0 00-2.104 0l-2.761 8.51H14.51c-.453.04-.839.35-.98.782-.143.435-.01.91.332 1.207l7.24 5.229-2.76 8.51a1.136 1.136 0 001.691 1.23l7.24-5.194 7.24 5.26a1.132 1.132 0 001.691-1.225l-2.762-8.58 7.24-5.23c.342-.297.475-.772.333-1.207a1.144 1.144 0 00-.98-.782zm-8.536 5.944c-.39.293-.555.808-.395 1.274l1.966 6.046-5.149-3.773c-.39-.271-.905-.271-1.296 0l-5.149 3.728 1.967-6.001a1.128 1.128 0 00-.395-1.225l-5.15-3.738h6.366v-.004c.47-.009.888-.315 1.043-.76l1.967-6.09 1.966 6.046a1.14 1.14 0 001.043.76h6.366l-5.15 3.737zm6.832 37.55c-.63 0-1.137.505-1.137 1.136v3.977l-9.228-8.079v-.004a1.139 1.139 0 00-1.456 0L17.28 70.93V59.792l.005.005a1.138 1.138 0 00-2.206 0V73.33c.026.417.284.79.665.963.382.173.83.124 1.163-.133l10.33-9.09 10.329 9.09a1.142 1.142 0 001.833-.83v-6.41a1.135 1.135 0 00-1.07-1.1z"}})])])
          )
        }
      }
    